/**
 * @file
 * Header script.
 */

(function headerScript($, Drupal) {
  'use strict';

  Drupal.behaviors.header = {
    attach: function (context) {
      var $header = $('.header--full-height', context);
      var $more = $('.header__more', $header);

      $more.on('click', function () {
        // Get the header's current offset.
        var topOffset = $header.height() + parseInt($header.css('paddingTop')) + parseInt($header.css('paddingBottom'));

        // Give a bit of spacing from the nav.
        var destinationOffset = topOffset - 52;

        // Scroll the body there.
        $('html, body', context).animate({
          scrollTop: destinationOffset + 'px'
        });
      });

      // Forcing focus on header search input if not hidden. Timeout is used to
      // trigger focus state after the page is rendered.
      setTimeout(function headerSearchTimeout() {
        if (!$('.header__inner .search-form__input', context).is(':hidden')) {
          $('.header__inner .search-form__input', context).focus();
        }
      }, 0);
    }
  };
}(jQuery, Drupal));
